import { Component, ElementRef, Input, OnInit, OnDestroy } from "@angular/core"
import { MediaTypeNavService } from "../../services/media-type-navigation.service"
import { Subscription } from "rxjs"

@Component({
    selector: "app-media-type-nav",
    templateUrl: "./media-type-nav.component.html",
    styleUrls: ["./media-type-nav.component.less"],
})
export class MediaTypeNavComponent implements OnInit, OnDestroy {
    @Input() availableAnchors: object[]
    selectedItem: string = ""
    subscriptions: Subscription[] = []

    constructor(private mediaTypeNavService: MediaTypeNavService, public el: ElementRef) {}

    ngOnInit() {
        this.subscriptions.push(
            this.mediaTypeNavService.categoryTitleInViewport.subscribe(
                (anchorID: string) => (this.selectedItem = anchorID)
            )
        )
    }

    onClick(targetID) {
        const targetElement = document.querySelector(`#${targetID}`)
        if (targetElement) {
            // TO DO: Uncomment and edit when implementing the sticky header behaviour
            // let targetOffset = this.getTargetOffset(targetElement);
            // window.scrollTo({ left: 0, top: targetOffset, behavior: 'smooth'});
            targetElement.scrollIntoView({ block: "start", behavior: "smooth" })
        }
    }

    getTargetOffset(targetElement) {
        const rect = targetElement.getBoundingClientRect().top
        const pageOffsetY = window.pageYOffset || document.documentElement.scrollTop
        const headerHeight = this.el.nativeElement.parentElement.clientHeight
        let offset = rect + pageOffsetY
        // Adjust scroll to account for header / sticky header
        if (document.querySelector(".header").classList.contains("sticky")) {
            offset -= headerHeight
        } else {
            offset -= headerHeight * 2
        }

        return offset
    }

    isAvailable(anchor) {
        return this.selectedItem.indexOf(anchor)
    }

    ngOnDestroy() {
        this.subscriptions.map((subscription) => subscription.unsubscribe())
    }
}
